import { render, staticRenderFns } from "./DashHumanResources.vue?vue&type=template&id=46353dd7&scoped=true&"
import script from "./DashHumanResources.vue?vue&type=script&lang=js&"
export * from "./DashHumanResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46353dd7",
  null
  
)

export default component.exports